import {useContext} from "react";
import {OrgDataContext, OrgDataProviderContext} from "context/orgData";
import {useQuery} from "react-apollo";
import {GET_ORGANIZATION, GET_VERIFLYT_ACCOUNT} from "./graphql";
import {OrganizationFragmentFragment, VeriflytAccountFragmentFragment} from "../../../__generated__/graphql/types";

type ValidOrgTypes = Parameters<OrgDataProviderContext['getOrgByType']>[0];

/**
 * Gets a veriflyt account associated with the current organization.
 */
export default function useVeriflytOrganization(orgType: ValidOrgTypes = null) {
    const orgData = useContext(OrgDataContext);

    const orgQueryRes = useQuery(GET_ORGANIZATION, {
        variables: {
            orgID: orgData.organization?._id
        },
        skip: !orgData.organization?._id,
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all'
    });

    const org = orgQueryRes.data?.getOrganization;

    const { data, loading, error, ...rest } = useQuery(GET_VERIFLYT_ACCOUNT, {
        variables: {
            veriflytID: org?.veriflytID
        },
        skip: !org?.veriflytID,
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all'
    });

    return {
        veriflytAccount: data?.GetVeriflytAccount as VeriflytAccountFragmentFragment,
        organization: orgData.organization as OrganizationFragmentFragment,
        loading: loading || orgQueryRes.loading,
        error: error || orgQueryRes.error,
        ...rest
    }
}